@if (isDatabaseInitializing) {
<div class="tw-w-full tw-min-h-[320px] tw-p-4 tw-space-y-4" role="status" aria-label="Loading database">
  <ngx-skeleton-loader
    count="1"
    [theme]="{ width: '100%', height: '48px', 'border-radius': '8px', backgroundColor: '#e5e7eb', marginBottom: '0' }"
    animation="pulse"
    class="tw-block"
  ></ngx-skeleton-loader>
  <div class="tw-flex tw-gap-2">
    <ngx-skeleton-loader
      count="1"
      [theme]="{ width: '96px', height: '36px', 'border-radius': '9999px', backgroundColor: '#e5e7eb', marginBottom: '0' }"
      animation="pulse"
      class="tw-block"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      count="1"
      [theme]="{ width: '112px', height: '36px', 'border-radius': '9999px', backgroundColor: '#e5e7eb', marginBottom: '0' }"
      animation="pulse"
      class="tw-block"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      count="1"
      [theme]="{ width: '80px', height: '36px', 'border-radius': '9999px', backgroundColor: '#e5e7eb', marginBottom: '0' }"
      animation="pulse"
      class="tw-block"
    ></ngx-skeleton-loader>
  </div>
  @for (_ of [1, 2, 3]; track $index) {
  <ngx-skeleton-loader
    count="1"
    [theme]="{ width: '100%', height: '56px', 'border-radius': '6px', backgroundColor: '#e5e7eb', marginBottom: '0' }"
    animation="pulse"
    class="tw-block tw-w-full"
  ></ngx-skeleton-loader>
  }
</div>
} @else if (!registrationsDataSourceCollection) {
<app-empty-data-table [eventId]="eventId" (personaCreated)="onEmptyStatePersonaCreated()"></app-empty-data-table>
} @else if (event) {
<div class="application-page full-width">
  <ngx-events-data-header
    *ngIf="registrationsDataSourceCollection"
    [currentEvent]="event"
    [registrationsDataSourceCollection]="registrationsDataSourceCollection"
    [selectionExists]="selectionExists"
    [activeFilters]="getActiveFiltersArray()"
    [clearSearch]="shouldClearSearch"
    [searchTerm]="lastSearchTerm"
    [clearFilterState]="shouldClearFilterState"
    [savedFilters]="getCurrentPersonaSavedFilters()"
    [membersOnlyMode]="membersOnlyMode"
    (searchTermChanged)="updateDataSources($event)"
    (filterStatusChanged)="filterStatus($event)"
    (autoRefreshChanged)="updateAutoRefresh($event)"
    (settleComplete)="updateDataSources()"
    (filterRemoved)="removeColumnFilter($event)"
    (allFiltersCleared)="clearAllColumnFilters()"
    (saveFilterRequested)="saveFilter($event)"
    (loadFilterRequested)="loadSavedFilter($event)"
    (deleteFilterRequested)="deleteSavedFilter($event)"
    (aiFiltersGenerated)="applyAIFilters($event)"
  >
  </ngx-events-data-header>

  <!-- Direct table view without tabset -->
  <div
    class="database"
    *ngIf="registrationsDataSourceCollection && registrationsDataSourceCollection.registrationsDataSources.length > 0"
    [ngClass]="{ 'actions-enabled': selectionExists }"
  >
    <!-- Persona switching loader -->
    <div class="persona-loading-overlay" *ngIf="isPersonaSwitching">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <p class="loading-text">Switching to {{ getTargetPersonaName() }}...</p>
      </div>
    </div>

    <cdk-virtual-scroll-viewport
      #viewport
      class="table-container database tw-overflow-x-auto tw-overflow-y-auto custom-scrollbar tw-pb-12"
      [class.loading]="isPersonaSwitching"
      autosize
      (scroll)="onScroll($event, registrationsDataSourceCollection.selectedIndex); onTableScroll()"
      (wheel)="onParentTableWheel($event)"
    >
      <table
        #table
        multiTemplateDataRows
        mat-table
        [dataSource]="getCurrentRegistrationsDataSource()"
        [fixedLayout]="true"
        [nbSpinner]="getCurrentRegistrationsDataSource()?.processing"
        [trackBy]="trackBy"
      >
        <!-- Number -->
        <ng-container matColumnDef="#order" sticky>
          <th mat-header-cell *matHeaderCellDef style="min-width: 40px">#</th>
          <td mat-cell *matCellDef="let registrant">
            {{ registrant.order }}
          </td>
        </ng-container>
        <!-- ./Number -->
        <!-- Check -->
        <ng-container matColumnDef="#select" sticky>
          <th mat-header-cell *matHeaderCellDef class="action-header-checkbox">
            <div class="d-flex justify-content-center align-items-center checkbox-action">
              <nb-checkbox
                [checked]="isChecked()"
                [indeterminate]="isIndeterminate()"
                (checkedChange)="updateToggleSelection($event, registrationsDataSourceCollection.selectedIndex)"
                *ngIf="!childSelectionActive"
              ></nb-checkbox>
            </div>
          </th>
          <td mat-cell *matCellDef="let registrant" class="action-cell" (click)="$event.stopPropagation()">
            <div class="d-flex justify-content-center align-items-center checkbox-action">
              <nb-checkbox [checked]="isRowSelected(registrant)" (checkedChange)="onParentRowCheckboxChange($event, registrant)" *ngIf="!childSelectionActive"></nb-checkbox>
            </div>
          </td>
        </ng-container>
        <!-- ./Check -->
        <!-- Flag -->
        <ng-container matColumnDef="#flag" sticky>
          <th mat-header-cell *matHeaderCellDef class="action-header-flag">
            <i class="far fa-flag"></i>
          </th>
          <td mat-cell *matCellDef="let registrant" class="action-cell" (click)="$event.stopPropagation()">
            <app-flag-dropdown [registrant]="registrant"></app-flag-dropdown>
          </td>
        </ng-container>
        <!-- ./Flag -->
        <!-- Barcode Key -->
        <ng-container matColumnDef="#barcode">
          <th mat-header-cell *matHeaderCellDef class="barcode-header-label">Unique code</th>
          <td mat-cell *matCellDef="let registrant" [ngxTippy]="registrant.barcode.trim()">{{ registrant.barcode.trim() }}</td>
        </ng-container>
        <!-- ./Barcode Key -->

        <!-- Fields -->
        <ng-container
          *ngFor="let columnDefinition of getCurrentRegistrationsDataSource()?.columnDefinitions; let i = index"
          [matColumnDef]="columnDefinition.field"
          [sticky]="i === 0"
        >
          <ng-container *ngIf="columnDefinition.field === 'main_point_of_contact'; else regularColumn">
            <th mat-header-cell *matHeaderCellDef class="action-header-field">Parent ID</th>
            <td mat-cell *matCellDef="let registrant">
              {{ registrant._source.parent.barcode }}
            </td>
          </ng-container>
          <ng-template #regularColumn>
            <th
              mat-header-cell
              *matHeaderCellDef
              class="action-header-field column-header-filterable"
              [ngClass]="{
                email: columnDefinition.field === 'email',
                fullName: columnDefinition.field === 'fullname',
                'has-filter': hasColumnFilter(columnDefinition.field),
                'is-sorted': sortField === columnDefinition.field
              }"
              [ngxTippy]="getTooltipValue(null, null, columnDefinition.header)"
              (mouseenter)="hoveredColumn = columnDefinition.field"
              (mouseleave)="hoveredColumn = null"
            >
              <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
                <div class="header-content" (click)="onColumnHeaderClick(columnDefinition.field)">
                  <span [innerHtml]="columnDefinition.header"></span>
                </div>
                <div class="tw-flex tw-items-center tw-gap-2">
                  <span class="sort-icons" (click)="onColumnHeaderClick(columnDefinition.field)">
                    <mat-icon *ngIf="sortField === columnDefinition.field" class="sort-indicator !tw-cursor-pointer">{{
                      sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                    <mat-icon *ngIf="sortField !== columnDefinition.field" class="sort-hint !tw-cursor-pointer" [class.visible]="hoveredColumn === columnDefinition.field"
                      >swap_vert</mat-icon
                    >
                  </span>

                  <!-- TODO: this is hidden cause of issues in filtration functionality and will be added back later when we fix the issues -->
                  @if(columnDefinition.field !== 'gender' && columnDefinition.field !== 'numeric') {
                  <button
                    class="filter-btn"
                    [class.visible]="hoveredColumn === columnDefinition.field || hasColumnFilter(columnDefinition.field)"
                    [class.active]="hasColumnFilter(columnDefinition.field)"
                    (click)="$event.stopPropagation(); openColumnFilter($event, columnDefinition)"
                    title="Filter"
                  >
                    <mat-icon>filter_list</mat-icon>
                  </button>
                  }
                </div>
              </div>
            </th>
            <td mat-cell *matCellDef="let registrant" (click)="onCalculatedFieldClick($event, registrant)" style="cursor: pointer">
              <a
                (mouseenter)="registrant.calculatedFields[columnDefinition.field].hovered = true"
                (mouseleave)="registrant.calculatedFields[columnDefinition.field].hovered = false"
                (mouseover)="registrant.calculatedFields[columnDefinition.field].hovered = true"
                (click)="$event.stopPropagation(); getCurrentRegistrationsDataSource()?.unhide(registrant, columnDefinition.field)"
                *ngIf="registrant.calculatedFields[columnDefinition.field]?.hidden; else fieldValue"
                >{{ registrant.calculatedFields[columnDefinition.field].hovered ? 'Show' : 'Hidden' }}</a
              >
              <ng-template #fieldValue>
                <!-- TODO: Refactor this logic of hiding perosna name -->
                <ng-container
                  *ngIf="
                    (!isElementOfType(getCurrentRegistrationsDataSource()?.form, columnDefinition.field, 'url') || !registrant.calculatedFields[columnDefinition.field]?.value) &&
                    !isUploadFieldType(columnDefinition.field)
                  "
                >
                  <div
                    class="tw-truncate"
                    style="white-space-collapse: preserve-breaks"
                    [ngxTippy]="getFieldValueTooltip(valueToShow(getCurrentRegistrationsDataSource()?.form, columnDefinition, registrant))"
                    [tippyProps]="fieldValueTippyProps"
                  >
                    {{
                      isUploadedImage(columnDefinition.field, registrant.calculatedFields[columnDefinition.field])
                        ? ''
                        : valueToShow(getCurrentRegistrationsDataSource()?.form, columnDefinition, registrant) || ''
                    }}
                  </div>
                </ng-container>
                <a
                  *ngIf="isElementOfType(getCurrentRegistrationsDataSource()?.form, columnDefinition.field, 'url') && registrant.calculatedFields[columnDefinition.field]?.value"
                  [href]="
                    registrant.calculatedFields[columnDefinition.field]?.value?.toLowerCase()?.includes('http')
                      ? registrant.calculatedFields[columnDefinition.field]?.value?.toLowerCase()
                      : 'https://' + registrant.calculatedFields[columnDefinition.field]?.value?.toLowerCase()
                  "
                  [ngxTippy]="getFieldValueTooltip(registrant.calculatedFields[columnDefinition.field]?.value?.toLowerCase())"
                  [tippyProps]="fieldValueTippyProps"
                  target="_blank"
                  (click)="$event.stopPropagation()"
                  >{{ registrant.calculatedFields[columnDefinition.field]?.value?.toLowerCase() }}</a
                >
                <div class="d-flex align-items-center file-container">
                  <img
                    class="thumbnail"
                    *ngIf="isUploadedImage(columnDefinition.field, registrant.calculatedFields[columnDefinition.field]) === 'image'"
                    [src]="registrant.calculatedFields[columnDefinition.field].value"
                    alt="Uploaded image"
                    loading="lazy"
                    (click)="$event.stopPropagation(); openImage(image, registrant.calculatedFields[columnDefinition.field].value, columnDefinition.header)"
                  />
                  <img
                    loading="lazy"
                    (click)="$event.stopPropagation(); openNewTab(registrant.calculatedFields[columnDefinition.field].value)"
                    class="thumbnail-icon"
                    src="https://library.micetribe.com/icons/file.svg"
                    alt="Uploaded file"
                    *ngIf="isUploadedImage(columnDefinition.field, registrant.calculatedFields[columnDefinition.field]) === 'file'"
                  />
                </div>
              </ng-template>
            </td>
          </ng-template>
        </ng-container>
        <!-- ./Fields -->

        <!-- Refund -->
        <ng-container matColumnDef="#refund">
          <th mat-header-cell *matHeaderCellDef class="action-header-toggle-button !tw-text-center">Refund</th>
          <td mat-cell *matCellDef="let registrant" class="action" (click)="$event.stopPropagation()">
            <button [disabled]="refundStatus(registrant) || isFinishedEvent()" class="btn-danger refund-button" (click)="refund(registrant)">
              {{ refundStatus(registrant) ? 'Refunded' : 'Refund' }}
            </button>
          </td>
        </ng-container>
        <!-- /Refund -->
        <!-- Remove after release/v2. -->
        <!-- Confirmation link-->
        <!-- <ng-container matColumnDef="#confirmation_link">
          <th mat-header-cell *matHeaderCellDef style="min-width: 200px !important" class="barcode-header-label">
            Confirmation link</th>
          <td mat-cell *matCellDef="let registrant" class="confirmation-link--td">
            <button *ngIf="isApproved(registrant)" nbTooltip="Open confirmation link" size="small" nbButton
              (click)="$event.stopPropagation(); openConfirmationLink(registrant)">
              <nb-icon pack="eva" icon="checkmark-square-outline" style="cursor: pointer"></nb-icon>
            </button>
          </td>
        </ng-container>
        <!-- ./Confirmation link-->

        <!-- Portal Link-->
        <ng-container matColumnDef="#portal_link">
          <th mat-header-cell *matHeaderCellDef class="action-header-field">Portal Link</th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <button size="small" nbButton (click)="$event.stopPropagation(); openEditDialog(registrant)" style="display: flex; align-items: center; gap: 4px">
              <span>Open</span>
              <nb-icon pack="eva" icon="external-link-outline" style="cursor: pointer"></nb-icon>
            </button>
          </td>
        </ng-container>
        <!-- ./Portal Link-->
        <!-- Members -->
        <ng-container matColumnDef="#members">
          <th mat-header-cell *matHeaderCellDef class="action-header-field members-header">Members</th>
          <td mat-cell *matCellDef="let registrant" class="action" (click)="onCalculatedFieldClick($event, registrant)" style="cursor: pointer">
            <div class="text-center">
              {{ registrant.child_count || 0 }}
            </div>
          </td>
        </ng-container>
        <!-- ./Members -->

        <!-- Registrations Limit -->
        <ng-container matColumnDef="#register_count">
          <th mat-header-cell style="min-width: 200px !important" *matHeaderCellDef class="action-header-field registration-limit-header">Registrations Limit</th>
          <td mat-cell *matCellDef="let registrant" class="action" (click)="$event.stopPropagation()">
            <div class="registration-counter">
              <button
                type="button"
                class="counter-btn"
                [disabled]="!canEditRegistrationLimit() || getDisplayedLimit(registrant) === 1"
                [ngClass]="{ 'counter-btn--disabled': !canEditRegistrationLimit() || getDisplayedLimit(registrant) === 1 }"
                (click)="$event.stopPropagation(); decrement(registrant)"
                [attr.title]="!canEditRegistrationLimit() ? 'You do not have permission to edit registration limits' : ''"
              >
                −
              </button>
              <input
                type="number"
                [value]="getDisplayedLimit(registrant)"
                (blur)="onLimitInputBlur(registrant, $event, $event)"
                class="counter-input"
                [disabled]="!canEditRegistrationLimit()"
                [attr.name]="'registration-limit-' + (registrant?.id || registrant?._source?.id || '')"
                [attr.id]="'registration-limit-' + (registrant?.id || registrant?._source?.id || '')"
                [min]="1"
                aria-label="Registration limit"
                inputmode="numeric"
                autocomplete="off"
                [attr.title]="!canEditRegistrationLimit() ? 'You do not have permission to edit registration limits' : ''"
              />
              <button
                type="button"
                class="counter-btn"
                [disabled]="!canEditRegistrationLimit()"
                [ngClass]="{ 'counter-btn--disabled': !canEditRegistrationLimit() }"
                (click)="increment(registrant)"
                [attr.title]="!canEditRegistrationLimit() ? 'You do not have permission to edit registration limits' : ''"
              >
                +
              </button>
            </div>
          </td>
        </ng-container>
        <!-- ./Registrations Limit -->
        <!-- Created at-->
        <ng-container matColumnDef="#created_at">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="barcode-header-label column-header-filterable"
            [ngClass]="{ 'has-filter': hasColumnFilter('#created_at'), 'is-sorted': sortField === '#created_at' }"
            (mouseenter)="hoveredColumn = '#created_at'"
            (mouseleave)="hoveredColumn = null"
          >
            <div class="header-content" (click)="onColumnHeaderClick('#created_at')">
              <span>Created at</span>
              <span class="sort-icons" (click)="onColumnHeaderClick('#created_at')">
                <mat-icon *ngIf="sortField === '#created_at'" class="sort-indicator !tw-cursor-pointer">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                <mat-icon *ngIf="sortField !== '#created_at'" class="sort-hint !tw-cursor-pointer" [class.visible]="hoveredColumn === '#created_at'">swap_vert</mat-icon>
              </span>
            </div>
            <button
              class="filter-btn"
              [class.visible]="hoveredColumn === '#created_at' || hasColumnFilter('#created_at')"
              [class.active]="hasColumnFilter('#created_at')"
              (click)="$event.stopPropagation(); openColumnFilter($event, '#created_at', 'Created at')"
              title="Filter"
            >
              <mat-icon class="!tw-cursor-pointer">filter_list</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let registrant" class="created-at--td">
            {{ registrant.created_at }}
          </td>
        </ng-container>
        <!-- ./Created at-->
        <!--Edit & Actions -->
        <ng-container matColumnDef="#actions">
          <th mat-header-cell *matHeaderCellDef class="action-header-checkbox">Actions</th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <div class="tw-flex tw-justify-between tw-items-center tw-gap-1">
              <div class="tw-w-8" *ngIf="!isGroupForm()">
                <button
                  nbButton
                  class="edit-icon"
                  ngxTippy="Edit Registration"
                  size="small"
                  style="width: 2rem; height: 2rem"
                  (click)="$event.stopPropagation(); openEditDialog(registrant)"
                >
                  <img src="https://library.micetribe.com/icons/edit.svg" alt="edit registrant" />
                </button>
              </div>
              <div class="tw-w-8">
                <button *ngIf="isApproved(registrant)" ngxTippy="Open confirmation link" size="small" nbButton (click)="$event.stopPropagation(); openConfirmationLink(registrant)">
                  <nb-icon pack="eva" icon="checkmark-square-outline" style="cursor: pointer"></nb-icon>
                </button>
              </div>
              <div class="tw-w-8">
                <button ngxTippy="Send confirmation" size="small" nbButton (click)="$event.stopPropagation(); openResendConfirmationForRegistrant(registrant)">
                  <nb-icon pack="eva" icon="sync-outline" style="cursor: pointer"></nb-icon>
                </button>
              </div>
            </div>
          </td>
        </ng-container>
        <!-- ./Edit -->
        <!-- SMS -->
        <ng-container matColumnDef="#sms">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="action-header-field column-header-filterable"
            [ngClass]="{
              'has-filter': hasColumnFilter('#sms'),
              'is-sorted': sortField === '#sms'
            }"
            (mouseenter)="hoveredColumn = '#sms'"
            (mouseleave)="hoveredColumn = null"
          >
            <div class="header-content" (click)="onColumnHeaderClick('#sms')">
              <span>SMS status</span>
              <span class="sort-icons" (click)="onColumnHeaderClick('#sms')">
                <mat-icon *ngIf="sortField === '#sms'" class="sort-indicator !tw-cursor-pointer">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                <mat-icon *ngIf="sortField !== '#sms'" class="sort-hint !tw-cursor-pointer" [class.visible]="hoveredColumn === '#sms'">swap_vert</mat-icon>
              </span>
            </div>
            <button
              class="filter-btn"
              [class.visible]="hoveredColumn === '#sms' || hasColumnFilter('#sms')"
              [class.active]="hasColumnFilter('#sms')"
              (click)="$event.stopPropagation(); openColumnFilter($event, '#sms', 'SMS status')"
              title="Filter"
            >
              <mat-icon class="!tw-cursor-pointer">filter_list</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <div class="h-100 d-flex justify-content-space-between align-items-center flex-row w-100">
              <span
                class="mr-2"
                [ngClass]="{
                  'text-success': registrant.smsStatus === 'Received',
                  'text-disabled': registrant.smsStatus === 'Pending',
                  'text-danger': registrant.smsStatus === 'Failed',
                  'text-warning-status': registrant.smsStatus === 'Not Supported'
                }"
                style="width: 100px !important"
                >{{ registrant.smsStatus }} <span *ngIf="registrant.smsStatus === 'Received'">({{ registrant.smsCount }})</span></span
              >
            </div>
          </td>
        </ng-container>
        <!-- ./SMS -->
        <!-- Email -->
        <ng-container matColumnDef="#email">
          <th
            mat-header-cell
            style="min-width: 200px !important"
            *matHeaderCellDef
            class="action-header-field column-header-filterable"
            [ngClass]="{
              'has-filter': hasColumnFilter('#email'),
              'is-sorted': sortField === '#email'
            }"
            (mouseenter)="hoveredColumn = '#email'"
            (mouseleave)="hoveredColumn = null"
          >
            <div class="header-content" (click)="onColumnHeaderClick('#email')">
              <span>Confirmation Email</span>
              <span class="sort-icons" (click)="onColumnHeaderClick('#email')">
                <mat-icon *ngIf="sortField === '#email'" class="sort-indicator !tw-cursor-pointer">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                <mat-icon *ngIf="sortField !== '#email'" class="sort-hint !tw-cursor-pointer" [class.visible]="hoveredColumn === '#email'">swap_vert</mat-icon>
              </span>
            </div>
            <button
              class="filter-btn"
              [class.visible]="hoveredColumn === '#email' || hasColumnFilter('#email')"
              [class.active]="hasColumnFilter('#email')"
              (click)="$event.stopPropagation(); openColumnFilter($event, '#email', 'Confirmation Email')"
              title="Filter"
            >
              <mat-icon class="!tw-cursor-pointer">filter_list</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <div class="h-100 d-flex justify-content-space-between align-items-center flex-row w-100">
              <span
                class="mr-2"
                [ngClass]="{
                  'text-success': registrant.mailStatus === 'Received',
                  'text-disabled': registrant.mailStatus === 'Bounced' || registrant.mailStatus === 'Blocked',
                  'text-danger': registrant.mailStatus === 'Failed'
                }"
                style="width: 100px !important"
                >{{ registrant.mailStatus }} <span *ngIf="!(registrant.mailStatus === '' || registrant.mailStatus === 'Sent')">({{ registrant.mailCount }}) </span>
              </span>
              <!-- <button *ngIf="registrant.canResendMail && isGroupForm()" nbTooltip="Resend confirmation ($0.02)" size="small" nbButton
                (click)="$event.stopPropagation(); openResendConfirmationForRegistrant(registrant)">
                <nb-icon pack="eva" icon="sync-outline" style="cursor: pointer"></nb-icon>
              </button> -->
            </div>
          </td>
        </ng-container>
        <!-- ./Email -->
        <!-- WhatsApp -->
        <ng-container matColumnDef="#whatsapp">
          <th
            mat-header-cell
            style="min-width: 200px !important"
            *matHeaderCellDef
            class="action-header-field column-header-filterable"
            [ngClass]="{
              'has-filter': hasColumnFilter('#whatsapp'),
              'is-sorted': sortField === '#whatsapp'
            }"
            (mouseenter)="hoveredColumn = '#whatsapp'"
            (mouseleave)="hoveredColumn = null"
          >
            <div class="header-content" (click)="onColumnHeaderClick('#whatsapp')">
              <span>WhatsApp status</span>
              <span class="sort-icons" (click)="onColumnHeaderClick('#whatsapp')">
                <mat-icon *ngIf="sortField === '#whatsapp'" class="sort-indicator !tw-cursor-pointer">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                <mat-icon *ngIf="sortField !== '#whatsapp'" class="sort-hint !tw-cursor-pointer" [class.visible]="hoveredColumn === '#whatsapp'">swap_vert</mat-icon>
              </span>
            </div>
            <button
              class="filter-btn"
              [class.visible]="hoveredColumn === '#whatsapp' || hasColumnFilter('#whatsapp')"
              [class.active]="hasColumnFilter('#whatsapp')"
              (click)="$event.stopPropagation(); openColumnFilter($event, '#whatsapp', 'WhatsApp status')"
              title="Filter"
            >
              <mat-icon class="!tw-cursor-pointer">filter_list</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <div class="h-100 d-flex justify-content-space-between align-items-center flex-row w-100">
              <span class="mr-2" style="width: 100px !important">
                {{ registrant.whatsappStatus }}
                <span *ngIf="registrant.whatsappCount > 0"> ({{ registrant.whatsappCount }}) </span>
              </span>
            </div>
          </td>
        </ng-container>
        <!-- ./WhatsApp -->
        <!-- Delete -->
        <ng-container matColumnDef="#delete">
          <th mat-header-cell *matHeaderCellDef class="action-header-checkbox"></th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <button size="small" nbButton (click)="$event.stopPropagation(); registrant.deleteSelf()">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <!-- ./Delete -->
        <!-- Approve -->
        <ng-container matColumnDef="#approve">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="action-header-toggle-button column-header-filterable"
            [ngClass]="{
              'has-filter': hasColumnFilter('#approve'),
              'is-sorted': sortField === '#approve'
            }"
            (mouseenter)="hoveredColumn = '#approve'"
            (mouseleave)="hoveredColumn = null"
          >
            <div class="header-content" (click)="onColumnHeaderClick('#approve')">
              <span>Approval status</span>
              <span class="sort-icons" (click)="onColumnHeaderClick('#approve')">
                <mat-icon *ngIf="sortField === '#approve'" class="sort-indicator !tw-cursor-pointer">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                <mat-icon *ngIf="sortField !== '#approve'" class="sort-hint !tw-cursor-pointer" [class.visible]="hoveredColumn === '#approve'">swap_vert</mat-icon>
              </span>
            </div>
            <button
              class="filter-btn"
              [class.visible]="hoveredColumn === '#approve' || hasColumnFilter('#approve')"
              [class.active]="hasColumnFilter('#approve')"
              (click)="$event.stopPropagation(); openColumnFilter($event, '#approve', 'Approval status')"
              title="Filter"
            >
              <mat-icon class="!tw-cursor-pointer">filter_list</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <div class="d-flex approval-container">
              <ngx-approval-statuses
                class="w-100"
                (click)="$event.stopPropagation()"
                [registrant]="registrant"
                [event]="event"
                [form]="getCurrentRegistrationsDataSource()?.form"
                (statusChange)="registrant.changeStatusTo($event)"
              >
              </ngx-approval-statuses>
            </div>
          </td>
        </ng-container>
        <!-- Approved / Declined By -->
        <ng-container matColumnDef="#approved_by">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="action-header-field text-center column-header-filterable"
            [ngClass]="{
              'has-filter': hasColumnFilter('#approved_by'),
              'is-sorted': sortField === '#approved_by'
            }"
            (mouseenter)="hoveredColumn = '#approved_by'"
            (mouseleave)="hoveredColumn = null"
          >
            <div class="header-content" (click)="onColumnHeaderClick('#approved_by')">
              <span>Approved / Declined By</span>
              <span class="sort-icons" (click)="onColumnHeaderClick('#approved_by')">
                <mat-icon *ngIf="sortField === '#approved_by'" class="sort-indicator !tw-cursor-pointer">{{
                  sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                }}</mat-icon>
                <mat-icon *ngIf="sortField !== '#approved_by'" class="sort-hint !tw-cursor-pointer" [class.visible]="hoveredColumn === '#approved_by'">swap_vert</mat-icon>
              </span>
            </div>
            <!-- TODO: this is hidden cause of issues in filtration functionality and will be added back later when we fix the issues -->
            <!-- <button
              class="filter-btn"
              [class.visible]="hoveredColumn === '#approved_by' || hasColumnFilter('#approved_by')"
              [class.active]="hasColumnFilter('#approved_by')"
              (click)="$event.stopPropagation(); openColumnFilter($event, '#approved_by', 'Approved / Declined By')"
              title="Filter"
            >
              <mat-icon class="!tw-cursor-pointer">filter_list</mat-icon>
            </button> -->
          </th>
          <td
            mat-cell
            *matCellDef="let registrant"
            (click)="$event.stopPropagation()"
            style="cursor: pointer"
            [ngxTippy]="getApprovedByTooltip(registrant)"
            [tippyProps]="{ allowHTML: true, maxWidth: 400 }"
          >
            <div class="text-center">
              {{ registrant.approvedOrDeclinedByDisplay }}
            </div>
          </td>
        </ng-container>
        <!-- Payment column -->
        <ng-container matColumnDef="#payment">
          <th mat-header-cell *matHeaderCellDef class="action-header-toggle-button text-center">Payment</th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <div class="d-flex">
              <p class="text-center w-100" *ngIf="registrant.payments.length > 0 && !registrant.payments[0].refund_amount && registrant.payments[0].amount; else noPayment">
                {{ registrant.payments[0].amount }}
              </p>
              <ng-template #noPayment>
                <span class="text-center w-100">-</span>
              </ng-template>
            </div>
          </td>
        </ng-container>
        <!-- ./Payment column -->

        <!-- Seatings -->
        <ng-container matColumnDef="#seating">
          <th mat-header-cell *matHeaderCellDef class="action-header-toggle-button">Selected seats</th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <div class="d-flex">
              <p>{{ registrant.selectedSeats }}</p>
            </div>
          </td>
        </ng-container>
        <!-- ./Seatings -->

        <!-- Attend -->
        <ng-container matColumnDef="#attend">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="action-header-toggle-button-left column-header-filterable"
            [ngClass]="{
              'has-filter': hasColumnFilter('#attend'),
              'is-sorted': sortField === '#attend'
            }"
            (mouseenter)="hoveredColumn = '#attend'"
            (mouseleave)="hoveredColumn = null"
          >
            <div class="header-content" (click)="onColumnHeaderClick('#attend')">
              <span>Attendance</span>
              <span class="sort-icons" (click)="onColumnHeaderClick('#attend')">
                <mat-icon *ngIf="sortField === '#attend'" class="sort-indicator !tw-cursor-pointer">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                <mat-icon *ngIf="sortField !== '#attend'" class="sort-hint !tw-cursor-pointer" [class.visible]="hoveredColumn === '#attend'">swap_vert</mat-icon>
              </span>
            </div>
            <!-- TODO: this is hidden cause of issues in filtration functionality and will be added back later when we fix the issues -->
            <!-- <button
              class="filter-btn"
              [class.visible]="hoveredColumn === '#attend' || hasColumnFilter('#attend')"
              [class.active]="hasColumnFilter('#attend')"
              (click)="$event.stopPropagation(); openColumnFilter($event, '#attend', 'Attendance')"
              title="Filter"
            >
              <mat-icon class="!tw-cursor-pointer">filter_list</mat-icon>
            </button> -->
          </th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <div class="d-flex align-items-center">
              <button
                type="button"
                class="attendance-chip"
                [class.on]="registrant.attended"
                [class.off]="!registrant.attended"
                [disabled]="!isEventStarted"
                ngxTippy="Mark attendees as attended or not once the event starts"
                (click)="$event.stopPropagation(); registrant.attended ? unattend(registrant) : attend(registrant)"
              >
                <nb-icon pack="eva" [icon]="registrant.attended ? 'checkmark-circle-2-outline' : 'radio-button-off-outline'"></nb-icon>
                <span>{{ registrant.attended ? 'Attended' : 'Not attended' }}</span>
              </button>
            </div>
          </td>
        </ng-container>
        <!-- ./Attend -->
        <!-- Badge prints -->
        <ng-container matColumnDef="#prints">
          <th mat-header-cell *matHeaderCellDef class="action-header-field">Badge prints</th>
          <td mat-cell *matCellDef="let registrant" class="action" [ngxTippy]="getPrintTooltip(registrant)" (click)="$event.stopPropagation(); openPrintHistory(registrant)">
            <div class="print-history-btn">
              <span class="print-count" *ngIf="registrant.hasPrintHistory(); else noPrintsParent">{{ registrant.printCount }}</span>
              <ng-template #noPrintsParent>
                <span class="print-meta">No prints</span>
              </ng-template>
            </div>
          </td>
        </ng-container>
        <!-- ./Badge prints -->
        <ng-container *ngFor="let day of event.event_timings; let i = index" matColumnDef="#day{{ i + 1 }}">
          <th
            style="min-width: 200px !important"
            mat-header-cell
            *matHeaderCellDef
            class="action-header-field text-center column-header-filterable"
            [ngClass]="{
              'has-filter': hasColumnFilter('#day' + (i + 1)),
              'is-sorted': sortField === '#day' + (i + 1)
            }"
            (mouseenter)="hoveredColumn = '#day' + (i + 1)"
            (mouseleave)="hoveredColumn = null"
          >
            <div class="header-content" (click)="onColumnHeaderClick('#day' + (i + 1))">
              <span>Day {{ i + 1 }} | {{ day.start_datetime | date : 'dd/MM/yyyy' }}</span>
              <span class="sort-icons" (click)="onColumnHeaderClick('#day' + (i + 1))">
                <mat-icon *ngIf="sortField === '#day' + (i + 1)" class="sort-indicator !tw-cursor-pointer">{{
                  sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                }}</mat-icon>
                <mat-icon *ngIf="sortField !== '#day' + (i + 1)" class="sort-hint !tw-cursor-pointer" [class.visible]="hoveredColumn === '#day' + (i + 1)">swap_vert</mat-icon>
              </span>
            </div>
            <button
              class="filter-btn"
              [class.visible]="hoveredColumn === '#day' + (i + 1) || hasColumnFilter('#day' + (i + 1))"
              [class.active]="hasColumnFilter('#day' + (i + 1))"
              (click)="$event.stopPropagation(); openColumnFilter($event, '#day' + (i + 1), 'Day ' + (i + 1) + ' Attendance')"
              title="Filter"
            >
              <mat-icon>filter_list</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let registrant" class="action">
            <div class="d-flex justify-content-center align-items-center">
              <span class="badge {{ isAttended(registrant, day).class }}">
                {{ isAttended(registrant, day).status }}
              </span>
            </div>
          </td>
        </ng-container>
        <!-- Filler -->
        <ng-container matColumnDef="#filler">
          <th mat-header-cell *matHeaderCellDef style="width: 100%"></th>
          <td mat-cell *matCellDef="let registrant" class="action"></td>
        </ng-container>
        <!-- ./Filler -->
        <tr mat-header-row *matHeaderRowDef="getCurrentRegistrationsDataSource()?.displayColumns"></tr>
        <tr
          mat-row
          *matRowDef="let registrant; columns: getCurrentRegistrationsDataSource()?.displayColumns; when: shouldShowRow"
          class="parent-row data-row"
          [attr.data-id]="registrant?.id"
          [class.row-expanded]="isExpanded(registrant)"
          [class.clickable]="getCurrentRegistrationsDataSource()?.form.type === 30"
          [class.flagged-red]="registrant.getFlagColor() === 'red'"
          [class.flagged-orange]="registrant.getFlagColor() === 'orange'"
          [class.flagged-green]="registrant.getFlagColor() === 'green'"
          (click)="getCurrentRegistrationsDataSource()?.form.type === 30 ? getChildRegistrations(registrant, registrant) : null"
        ></tr>
        <ng-container matColumnDef="childDetail">
          <td mat-cell *matCellDef="let registrant" [attr.colspan]="getCurrentRegistrationsDataSource()?.displayColumns.length">
            <div class="child-detail-wrapper pl-40" [class.child-detail-wrapper-expanded]="isExpanded(registrant)" style="width: 100%; padding: 0">
              <div class="child-detail" style="width: 100%">
                <div class="mat-elevation-z8" style="width: 100%">
                  <div
                    class="child-table-container custom-scrollbar tw-overflow-x-auto tw-overflow-y-auto"
                    [class.loading]="isChildTableLoading"
                    (scroll)="onChildTableScroll($event)"
                    (wheel)="onChildTableWheel($event)"
                    style="width: 100%; position: relative; -webkit-overflow-scrolling: touch"
                  >
                    <!-- Branded loader while fetching child rows -->
                    <div class="child-brand-loader" *ngIf="isChildTableLoading">
                      <div class="loader-card">
                        <app-logo class="brand"></app-logo>
                        <div class="progress">
                          <div class="bar"></div>
                        </div>
                        <div class="hint">Loading group members…</div>
                      </div>
                    </div>
                    <ng-container *ngIf="!isChildTableLoading && dataSource?.data?.length; else noChildren">
                      <table mat-table [dataSource]="dataSource" class="full-width-table" style="width: 100%">
                        <ng-container matColumnDef="#select">
                          <th mat-header-cell *matHeaderCellDef class="action-header-checkbox">
                            <div class="d-flex justify-content-center align-items-center checkbox-action">
                              <nb-checkbox
                                *ngIf="!parentSelectionActive && workspaceRoleService.canAccessBulkActions()"
                                [checked]="isChildChecked()"
                                [indeterminate]="isChildIndeterminate()"
                                (checkedChange)="updateToggleSelectionChild($event, registrationsDataSourceCollection.selectedIndex)"
                              ></nb-checkbox>
                            </div>
                          </th>
                          <td mat-cell *matCellDef="let registrant" class="action-cell">
                            <div class="d-flex justify-content-center align-items-center checkbox-action">
                              <nb-checkbox
                                *ngIf="!parentSelectionActive && workspaceRoleService.canAccessBulkActions()"
                                [checked]="isChildRowSelected(registrant)"
                                (checkedChange)="childSelection($event, registrant)"
                              ></nb-checkbox>
                            </div>
                          </td>
                        </ng-container>

                        <!-- Flag column for child table -->
                        <ng-container matColumnDef="#flag">
                          <th mat-header-cell *matHeaderCellDef class="action-header-flag">
                            <i class="far fa-flag"></i>
                          </th>
                          <td mat-cell *matCellDef="let registrant" class="action-cell" (click)="$event.stopPropagation()">
                            <app-flag-dropdown [registrant]="registrant"></app-flag-dropdown>
                          </td>
                        </ng-container>

                        <!-- Barcode column for child table -->
                        <ng-container matColumnDef="#child-barcode">
                          <th mat-header-cell *matHeaderCellDef class="barcode-header-label">Unique code</th>
                          <td mat-cell *matCellDef="let registrant">{{ registrant.barcode.trim() }}</td>
                        </ng-container>

                        <ng-container *ngFor="let columnDefinition of columnsDefinition; let i = index" [matColumnDef]="columnDefinition.field">
                          <ng-template [ngIf]="columnDefinition.field === 'main_point_of_contact'">
                            <th mat-header-cell *matHeaderCellDef class="action-header-field">Parent ID</th>
                            <td mat-cell *matCellDef="let registrant">
                              {{ registrant._source.parent.barcode }}
                            </td>
                          </ng-template>
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            [innerHtml]="columnDefinition.header"
                            [ngxTippy]="getTooltipValue(null, null, columnDefinition.header)"
                            class="action-header-field"
                            [ngClass]="{ email: columnDefinition.field === 'email', fullName: columnDefinition.field === 'fullname' }"
                          ></th>
                          <td mat-cell *matCellDef="let registrant">
                            <a
                              (mouseenter)="registrant.calculatedFields[columnDefinition.field].hovered = true"
                              (mouseleave)="registrant.calculatedFields[columnDefinition.field].hovered = false"
                              (mouseover)="registrant.calculatedFields[columnDefinition.field].hovered = true"
                              (click)="$event.stopPropagation(); getCurrentRegistrationsDataSource()?.unhide(registrant, columnDefinition.field)"
                              *ngIf="registrant.calculatedFields[columnDefinition.field]?.hidden; else fieldValue"
                              >{{ registrant.calculatedFields[columnDefinition.field].hovered ? 'Show' : 'Hidden' }}</a
                            >
                            <ng-template #fieldValue>
                              <!-- TODO: Refactor this logic of hiding perosna name -->
                              <ng-container
                                *ngIf="!isElementOfType(currentChildForm, columnDefinition.field, 'url') || !registrant.calculatedFields[columnDefinition.field]?.value"
                              >
                                <div
                                  class="tw-truncate"
                                  style="white-space-collapse: preserve-breaks"
                                  [ngxTippy]="getFieldValueTooltip(valueToShow(currentChildForm, columnDefinition, registrant))"
                                  [tippyProps]="fieldValueTippyProps"
                                >
                                  <span *ngIf="columnDefinition.field.includes('checkbox')" [innerHTML]="valueToShow(currentChildForm, columnDefinition, registrant) || ''"> </span>
                                  <span *ngIf="!columnDefinition.field.includes('checkbox')">
                                    {{
                                      isUploadedImage(columnDefinition.field, registrant.calculatedFields[columnDefinition.field])
                                        ? ''
                                        : valueToShow(currentChildForm, columnDefinition, registrant) || ''
                                    }}
                                  </span>
                                </div>
                              </ng-container>
                              <a
                                *ngIf="isElementOfType(currentChildForm, columnDefinition.field, 'url') && registrant.calculatedFields[columnDefinition.field]?.value"
                                [href]="
                                  registrant.calculatedFields[columnDefinition.field]?.value?.toLowerCase()?.includes('http')
                                    ? registrant.calculatedFields[columnDefinition.field]?.value?.toLowerCase()
                                    : 'https://' + registrant.calculatedFields[columnDefinition.field]?.value?.toLowerCase()
                                "
                                [ngxTippy]="getFieldValueTooltip(registrant.calculatedFields[columnDefinition.field]?.value?.toLowerCase())"
                                [tippyProps]="fieldValueTippyProps"
                                target="_blank"
                                >{{ registrant.calculatedFields[columnDefinition.field]?.value?.toLowerCase() }}</a
                              >
                              <div class="d-flex align-items-center file-container">
                                <img
                                  class="thumbnail"
                                  *ngIf="isUploadedImage(columnDefinition.field, registrant.calculatedFields[columnDefinition.field]) === 'image'"
                                  [src]="registrant.calculatedFields[columnDefinition.field].value"
                                  alt="Uploaded image"
                                  loading="lazy"
                                  (click)="openImage(image, registrant.calculatedFields[columnDefinition.field].value, columnDefinition.header)"
                                />
                                <img
                                  loading="lazy"
                                  (click)="openNewTab(registrant.calculatedFields[columnDefinition.field].value)"
                                  class="thumbnail-icon"
                                  src="https://library.micetribe.com/icons/file.svg"
                                  alt="Uploaded file"
                                  *ngIf="isUploadedImage(columnDefinition.field, registrant.calculatedFields[columnDefinition.field]) === 'file'"
                                />
                              </div>
                            </ng-template>
                          </td>
                        </ng-container>
                        <!--Edit & Actions -->
                        <ng-container matColumnDef="#actions">
                          <th mat-header-cell *matHeaderCellDef class="action-header-checkbox">Actions</th>
                          <td mat-cell *matCellDef="let registrant" class="action">
                            <div class="tw-flex tw-justify-between tw-items-center tw-gap-1">
                              <div class="tw-w-8">
                                <button
                                  nbButton
                                  class="edit-icon"
                                  style="width: 2rem; height: 2rem"
                                  ngxTippy="Edit Registration"
                                  size="small"
                                  (click)="$event.stopPropagation(); openEditDialog(registrant)"
                                >
                                  <img src="https://library.micetribe.com/icons/edit.svg" alt="edit registrant" />
                                </button>
                              </div>
                              <div class="tw-w-8">
                                <button
                                  *ngIf="isApproved(registrant)"
                                  ngxTippy="Open confirmation link"
                                  size="small"
                                  nbButton
                                  (click)="$event.stopPropagation(); openConfirmationLink(registrant)"
                                >
                                  <nb-icon pack="eva" icon="checkmark-square-outline" style="cursor: pointer"></nb-icon>
                                </button>
                              </div>
                              <div class="tw-w-8">
                                <button ngxTippy="Send confirmation" size="small" nbButton (click)="$event.stopPropagation(); openResendConfirmationForRegistrant(registrant)">
                                  <nb-icon pack="eva" icon="sync-outline" style="cursor: pointer"></nb-icon>
                                </button>
                              </div>
                            </div>
                          </td>
                        </ng-container>
                        <!-- ./Edit -->
                        <ng-container matColumnDef="#approve">
                          <th mat-header-cell *matHeaderCellDef class="action-header-toggle-button-left">Approval status</th>
                          <td mat-cell *matCellDef="let registrant" class="action">
                            <div class="d-flex">
                              <ngx-approval-statuses
                                *ngIf="currentChildForm"
                                (click)="$event.stopPropagation()"
                                [registrant]="registrant"
                                [event]="event"
                                (statusChange)="changeStatusChild($event, registrant)"
                                [form]="currentChildForm"
                              >
                              </ngx-approval-statuses>
                            </div>
                          </td>
                        </ng-container>
                        <!-- Approved / Declined By -->
                        <ng-container matColumnDef="#approved_by">
                          <th mat-header-cell *matHeaderCellDef class="action-header-field text-center">Approved / Declined By</th>
                          <td
                            mat-cell
                            *matCellDef="let registrant"
                            (click)="$event.stopPropagation()"
                            style="cursor: pointer"
                            [ngxTippy]="getApprovedByTooltip(registrant)"
                            [tippyProps]="{ allowHTML: true, maxWidth: 400 }"
                          >
                            <div class="text-center">
                              {{ registrant.approvedOrDeclinedByDisplay }}
                            </div>
                          </td>
                        </ng-container>
                        <!-- ./Approved / Declined By -->

                        <ng-container matColumnDef="#attend">
                          <th mat-header-cell *matHeaderCellDef class="action-header-toggle-button-left">Attendance</th>
                          <td mat-cell *matCellDef="let registrant" class="action">
                            <div class="d-flex align-items-center">
                              <button
                                type="button"
                                class="attendance-chip"
                                [class.on]="registrant.attended"
                                [class.off]="!registrant.attended"
                                [disabled]="!isEventStarted"
                                [ngxTippy]="!isEventStarted ? 'Event not started' : registrant.attended ? 'Click to mark not attended' : 'Click to mark attended'"
                                (click)="$event.stopPropagation(); registrant.attended ? unattendChild(registrant) : attendChild(registrant)"
                              >
                                <nb-icon pack="eva" [icon]="registrant.attended ? 'checkmark-circle-2-outline' : 'radio-button-off-outline'"></nb-icon>
                                <span>{{ registrant.attended ? 'Attended' : 'Not attended' }}</span>
                              </button>
                            </div>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="#prints">
                          <th mat-header-cell *matHeaderCellDef class="action-header-field">Badge prints</th>
                          <td
                            mat-cell
                            *matCellDef="let registrant"
                            class="action"
                            [ngxTippy]="getPrintTooltip(registrant)"
                            (click)="$event.stopPropagation(); openPrintHistory(registrant)"
                          >
                            <div class="print-history-btn">
                              <span class="print-count" *ngIf="registrant.hasPrintHistory(); else noPrintsChild">{{ registrant.printCount }}</span>
                              <ng-template #noPrintsChild>
                                <span class="print-meta">No prints</span>
                              </ng-template>
                            </div>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="#email">
                          <th mat-header-cell style="min-width: 200px !important" *matHeaderCellDef class="action-header-field">Confirmation Email</th>
                          <td mat-cell *matCellDef="let registrant" class="action">
                            <div class="h-100 d-flex justify-content-space-between align-items-center flex-row w-100">
                              <span
                                class="mr-2"
                                [ngClass]="{
                                  'text-success': registrant.mailStatus === 'Received',
                                  'text-disabled': registrant.mailStatus === 'Bounced' || registrant.mailStatus === 'Blocked',
                                  'text-danger': registrant.mailStatus === 'Failed'
                                }"
                                style="width: 100px !important"
                                >{{ registrant.mailStatus }}
                                <span *ngIf="!(registrant.mailStatus === '' || registrant.mailStatus === 'Sent')">({{ registrant.mailCount }}) </span>
                              </span>
                              <!-- Remove after release/v2. -->
                              <!-- <button *ngIf="registrant.canResendMail" nbTooltip="Resend confirmation ($0.02)"
                                size="small" nbButton
                                (click)="$event.stopPropagation(); openResendConfirmationForRegistrant(registrant)">
                                <nb-icon pack="eva" icon="sync-outline" style="cursor: pointer"></nb-icon>
                              </button> -->
                            </div>
                          </td>
                        </ng-container>

                        <!-- SMS column for child table -->
                        <ng-container matColumnDef="#sms">
                          <th mat-header-cell *matHeaderCellDef class="action-header-field">SMS status</th>
                          <td mat-cell *matCellDef="let registrant" class="action">
                            <div class="h-100 d-flex justify-content-space-between align-items-center flex-row w-100">
                              <span
                                class="mr-2"
                                [ngClass]="{
                                  'text-success': registrant.smsStatus === 'Received',
                                  'text-disabled': registrant.smsStatus === 'Pending',
                                  'text-danger': registrant.smsStatus === 'Failed',
                                  'text-warning-status': registrant.smsStatus === 'Not Supported'
                                }"
                                style="width: 100px !important"
                                >{{ registrant.smsStatus }} <span *ngIf="registrant.smsStatus === 'Received'">({{ registrant.smsCount }})</span></span
                              >
                            </div>
                          </td>
                        </ng-container>
                        <!-- /WhatsApp column for child table -->
                        <ng-container matColumnDef="#whatsapp">
                          <th mat-header-cell *matHeaderCellDef class="action-header-field">WhatsApp status</th>
                          <td mat-cell *matCellDef="let registrant" class="action">
                            <div class="h-100 d-flex justify-content-space-between align-items-center flex-row w-100">
                              <span
                                class="mr-2"
                                [ngClass]="{
                                  'text-success': registrant.whatsappStatus === 'Received',
                                  'text-disabled': registrant.whatsappStatus === 'Pending',
                                  'text-danger': registrant.whatsappStatus === 'Failed'
                                }"
                                style="width: 100px !important"
                                >{{ registrant.whatsappStatus }} <span *ngIf="registrant.whatsappStatus === 'Received'">({{ registrant.whatsappCount }})</span></span
                              >
                            </div>
                          </td>
                        </ng-container>
                        <!-- Created at column for child table -->
                        <ng-container matColumnDef="#created_at">
                          <th mat-header-cell *matHeaderCellDef class="barcode-header-label">Created at</th>
                          <td mat-cell *matCellDef="let registrant" class="created-at--td">
                            {{ registrant.created_at }}
                          </td>
                        </ng-container>

                        <!-- Day columns for child table -->
                        <ng-container *ngFor="let day of event.event_timings; let i = index" matColumnDef="#child-day{{ i + 1 }}">
                          <th style="min-width: 200px !important" mat-header-cell *matHeaderCellDef class="action-header-field text-center">
                            Day {{ i + 1 }} | {{ day.start_datetime | date : 'dd/MM/yyyy' }}
                          </th>
                          <td mat-cell *matCellDef="let registrant" class="action">
                            <div class="d-flex justify-content-center align-items-center">
                              <span class="badge {{ isAttended(registrant, day).class }}">
                                {{ isAttended(registrant, day).status }}
                              </span>
                            </div>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="child-header-row"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                      </table>
                    </ng-container>
                    <ng-template #noChildren>
                      <div class="child-empty" *ngIf="!isChildTableLoading">
                        <h6 class="text-hint">No registrations</h6>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let registrant; columns: ['childDetail']; when: isExpandedRow" class="child-detail-row"></tr>
      </table>

      <div class="d-flex justify-content-center align-items-center my-3" *ngIf="!getCurrentRegistrationsDataSource()?.data?.length">
        <h6 class="text-hint">
          {{
            getCurrentRegistrationsDataSource()?.processing
              ? 'Loading...'
              : getCurrentRegistrationsDataSource()?.initializeRequest?.searchTerm === ''
              ? 'This persona has no registrations'
              : 'No registrations matching the search criteria `' + getCurrentRegistrationsDataSource()?.initializeRequest?.searchTerm + '`'
          }}
        </h6>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
}

<!-- Bulk actions -->

<!-- Bulk flag -->
<ng-template #bulkFlag let-ref="dialogRef" let-data>
  <nb-card>
    <nb-card-body>
      <div class="modal-message">Are you sure you want to flag {{ registrationsDataSourceCollection.selected.length }} registrants</div>
    </nb-card-body>
    <nb-card-footer>
      <div class="modal-actions">
        <button nbButton status="basic" (click)="ref.close()">cancel</button>
        <button nbButton status="danger" (click)="registrationsDataSourceCollection.flagSelections(); ref.close()">Flag</button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
<!-- ./Bulk flag -->

<!-- Bulk unflag -->
<ng-template #bulkUnflag let-ref="dialogRef">
  <nb-card>
    <nb-card-body>
      <div class="modal-message">Are you sure you want to un-flag {{ registrationsDataSourceCollection.selected.length }} registrants?</div>
    </nb-card-body>
    <nb-card-footer>
      <div class="modal-actions">
        <button nbButton status="basic" (click)="ref.close()">cancel</button>
        <button nbButton status="primary" (click)="registrationsDataSourceCollection.unflagSelections(); ref.close()">Unflag</button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
<!-- ./Bulk unflag -->

<!-- ./Bulk actions -->

<!-- Persona Switcher - Fixed at bottom of page -->
<app-persona-switcher
  *ngIf="registrationsDataSourceCollection && !selectionExists"
  [personas]="getPersonasForSwitcher()"
  [selectedIndex]="registrationsDataSourceCollection.selectedIndex"
  [disabled]="selectionExists"
  (personaChanged)="onPersonaSelected($event)"
>
</app-persona-switcher>

<!-- Bulk Progress Toast -->
<app-bulk-progress-toast></app-bulk-progress-toast>

<!-- Image modal -->
<ng-template #image>
  <div class="modal-content">
    <div class="modal-header">
      <span class="modal-title"></span>
      <mat-icon aria-hidden="false" aria-label="Close" style="cursor: pointer" (click)="closeImageModal()">close</mat-icon>
    </div>
    <div class="modal-body d-flex flex-column justify-content-center align-items-center" [nbSpinner]="isRotatingImage" nbSpinnerMessage="Rotating your image">
      <img *ngIf="!isRotatingImage" loading="lazy" [src]="imageSource" (click)="$event.stopPropagation()" />
      <span class="rotate-button" ngxTippy="Rotate the image clockwise" (click)="$event.stopPropagation(); rotateImage()"> <mat-icon>rotate_right</mat-icon></span>
    </div>
  </div>
</ng-template>
<!-- ./Image modal -->

<!-- Filter Dropdown - uses shared app-dropdown for portal, positioning, and outside-click -->
<app-dropdown
  #columnFilterDropdown
  *ngIf="activeFilterColumn"
  [componentWithDataSetter]="columnFilterContentSetter"
  [widthInPX]="'320px'"
  [minWidthInPX]="'280px'"
  [maxHeightInPX]="500"
  [dropdownListXPosition]="'auto'"
  [dropdownListYPosition]="'bottom'"
  [positionAtClick]="true"
  [exceptionSelector]="'.column-filter-dropdown,.filter-btn'"
  (dropdownClosed)="closeColumnFilter()"
  class="column-filter-dropdown-host"
>
  <span class="column-filter-trigger" aria-hidden="true"></span>
</app-dropdown>

<!-- Comment Modal -->
<ng-template #commentModal let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Add Comment</nb-card-header>
    <nb-card-body>
      <ngx-editor [message]="commentContent" [height]="200" [showMenuBar]="true" [placeholder]="'Enter your comment...'" (valueChange)="commentContent = $event"></ngx-editor>
    </nb-card-body>
    <nb-card-footer>
      <div class="modal-actions">
        <button nbButton status="basic" (click)="closeCommentModal(); ref.close()">Cancel</button>
        <button nbButton status="primary" (click)="saveFlagWithComment(); ref.close()">Save</button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
